// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".analysis-class h3,.analysis-class h4{font-size:1rem!important}.analysis-class .reference-answer p{margin-bottom:0!important}", ""]);
// Exports
module.exports = exports;
